<template>
  <div class="panel search-panel">
    <div class="panel-content">
      <div class="panel-title space">
        <q-btn flat dense
          icon="keyboard_arrow_left"
          size="md"
          @click="$router.go(-1)"
        />
        <q-spinner v-if="loading"/>
        <span v-else-if="hasErrors" > {{ t('resultsError') }}</span>
        <span v-else>
          {{ title }}
        </span>
      </div>
      <div v-if="result">
        <div v-if="urlImg" class="q-my-md">
          <q-img :src="urlImg" class="rounded-borders"/>
        </div>
        <div v-if="notes">
          <div class="panel-title">Descripció</div>
          {{ notes }}
        </div>
        <div v-if="formats" class="q-my-md">
          <div class="panel-title">Formats</div>
          <div class="row">
            <div v-for="format in formats" v-bind:key="format" class="q-pa-xs">
              <q-badge :label="format" :style="'background:' + formatColor[format.toLowerCase()]"/>
            </div>
          </div>
        </div>
        <p class="linkReus">
          <a :href="'https://opendata.reus.cat/dataset/' + result.name" target="_blank">
            Obra el recurs a ReusOpenData
            <i class="fas fa-arrow-alt-circle-right"></i>
          </a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { QBtn, QBadge, QImg, QSpinner } from 'quasar'
import { mapState } from 'vuex'

export default {
  components: {
    QBtn,
    QBadge,
    QImg,
    QSpinner
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$store.dispatch('openData/searchById', to.params.q)
    })
  },
  beforeRouteLeave (to, from, next) {
    this.$store.dispatch('openData/clearResult')
    next()
  },
  data () {
    return {
      formatColor: {
        geojson: '#9855e0',
        csv: '#dfb100',
        json: '#ef7100',
        xml: '#a6cf4e'
      }
    }
  },
  computed: {
    ...mapState({
      hasErrors: state => state.openData.errorFetching,
      loading: state => state.openData.loading,
      result: state => state.openData.result
    }),

    formats () {
      const formats_ = this.result && this.result.resources && this.result.resources.map(resource => resource.format)
      return formats_ && [...new Set(formats_)]
    },
    notes () {
      return this.result && this.result.notes
    },
    title () {
      return this.result && this.result.title
    },
    urlImg () {
      const url = this.result && this.result.extras && this.result.extras.filter(extra => extra.key === 'urlImatge')
      return url && url.length > 0 && url[0].value
    }
  },
  watch: {
    formats: function (formats) {
      let i = formats.map(format => format.toLowerCase()).indexOf('geojson')
      if (i !== -1) {
        this.$store.dispatch('openData/getGeoJSON', this.result.resources[i].url)
      } else {
        i = formats.map(format => format.toLowerCase()).indexOf('json')
        if (i !== -1) {
          this.$store.dispatch('openData/getJSON', this.result.resources[i].url)
        }
      }
    }
  },
  methods: {
    t (key, ...args) {
      return this.$t('tools.search.' + key, ...args)
    }
  }
}
</script>

<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #752641;
}
p.linkReus {
  font-size: 16px;
}
</style>
